import { dateToyyyyMMdd } from "../../../../../util/date";
import { normalizeVatNumber } from "../../../../../util/vatValidation";
import {
  OpretFirmaDTO,
  OpretFirmaStep1Formik,
  OpretFirmaStep2Formik,
} from "../../opretFirmaInterface";

export const getOpretUDLFirmaDTO = ({
  step1,
  step2,
}: {
  step1: OpretFirmaStep1Formik;
  step2: OpretFirmaStep2Formik;
}): OpretFirmaDTO => {
  const {
    advokatVirksomhed,
    navn,
    periodeFraDato,
    virksomhedsform,
    andenAdresse,
    udenlandskCvr,
  } = step1;
  const {
    ean,
    email,
    emailFaktura,
    fakturaAfsend,
    phone,
    website,
    selskabstype,
  } = step2;
  return {
    advokatVirksomhed,
    beliggenhedsadresse: andenAdresse,
    ean,
    email,
    fakturaEmail: emailFaktura,
    navn1: navn,
    navn2: "",
    navn3: "",
    tlf: phone,
    webAdresse: website,
    fakturaAfsend: fakturaAfsend ?? null,
    periodeFraDato: periodeFraDato ? dateToyyyyMMdd(periodeFraDato) : null,
    cvrNr: null,
    kommuneNr: null,
    kredsNr: 1,
    pnr: null,
    regionNr: null,
    retskredsNr: null,
    virksomhedsform: virksomhedsform ?? null,
    selskabstype: selskabstype ? parseInt(selskabstype) : null,
    bemaerkninger: null,
    udenlandskVirksomhedsId: udenlandskCvr
      ? normalizeVatNumber(udenlandskCvr)
      : null,
  };
};
